type StoreEntry = {
  name: string;
  reset: () => void;
};

const stores: StoreEntry[] = [];

const sortStores = (a: StoreEntry, b: StoreEntry) => {
  if (a.name === 'authentication-store') {
    return 1;
  }
  if (b.name === 'authentication-store') {
    return -1;
  }
  return 0;
};

export const addStore = (store: StoreEntry) => {
  stores.push(store);
};

export const resetAll = () => {
  [...stores].sort(sortStores).forEach(store => store.reset());
};
